<template>
  <div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;">
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb> -->
        <div style="border-bottom: 1px solid #eeeeee;height:22px;padding:20px;">
            <div style="text-align:left;height:20px;line-height:20px;">
                <div style="float:left;border-left: 4px solid #42b6ff;height:20px;"></div>
                <div style="float:left;margin-left:8px;"><span>待处理的评估任务</span></div>
                <div style="float:left;margin-left:10px;"><el-badge :value="RC_todo" /></div>
            </div>
        </div>
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="调研任务" name="first">
                <todo-list ref="todo_list"></todo-list>
            </el-tab-pane> -->
            <!-- 20240827 报告功能先暂停使用 -->
            <!-- <el-tab-pane label="结果报告" name="second" v-if="is_superior=='是'">
                <rc-results ref="rc_results"></rc-results>
            </el-tab-pane> -->
            <!-- <el-tab-pane label="激励资源" name="third">
                <div style="text-align:left;font-size:16px;color:#67C23A;margin-bottom:15px;margin-top:20px;">
                    <p style="margin: 0px;">
                        <span v-if="is_superior=='是'">对于以下激励资源，请填写您的使用频率：</span>
                        <span v-else>对于以下激励资源，请填写您上级的使用频率：</span>
                    </p>
                </div>
                <resour-mana ref="resour_mana" :resource_info="resource_info" style="margin-top:20px;"></resour-mana>
                <div style="margin-top:50px;">
                    <el-button @click="save_results">保 存</el-button>
                    <el-button type="primary" @click="submit_results" style="margin-left:30px;">提 交</el-button>
                </div>
            </el-tab-pane> -->
        <!-- </el-tabs> -->
        <div style="margin-top:17px;padding:0 20px;">
            <todo-list ref="todo_list" @sendToDoNum="getToDoNum"></todo-list>
        </div>
  </div>
</template>

<script>
import todoList from "./RC_todo.vue";
// import rcResults from "./RC_results.vue";
// import resourMana from "../QuestionManagement/RC_resource.vue";
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    beforeCreate() {
        let params = {
            task_type: "RC",
        }
        getdata.getListP("checklogin", params)
              .then((resp) => {
                this.is_superior = resp.data.is_superior;
                this.task_id = resp.data.task_id;
                // this.getRCResource();
              })
              .catch(() => {
                if(localStorage.getItem("token") != null){
                    this.$message({
                        message: '会话超时，请重新登录！',
                        type: 'warning',
                    })
                }
                this.$router.push({
                    path: '/RClogin',
                });
              })
    },
    created() {
        // this.getToDoList();
        
    },
    // beforeUpdate() {
    //     this.display_flag = true;
    // },
    components: {
        // quesmana,
        todoList,
        // rcResults,
        // resourMana,
    },
    data() {
        return {
            task_list: [],
            form: {},
            dialogFormVisible: false,
            dialogFormVisible_survey: false,
            submit_question_info: [],
            submit_survey_info: [],
            submit_proof_info: [],
            qid_list: [],
            result_list: [],
            request_info: {},
            unfinish_num: 0,
            question_info: [],
            survey_info: [],
            proof_info: [],
            check_flag: true,
            error_flag: false,  //标识检查是否有错误，用于标红未答的主观题
            check_flag_survey: true,
            error_flag_survey: false,  //标识检查是否有错误，用于标红未答的主观题
            login_random_series: null,
            login_task_id: null,
            timer: null,
            timer2: null,
            timer_flag: false,      // 定时器状态：false销毁定时器，true打开定时器
            show: false,
            submit_times: 0,        // 问卷提交次数，当次数>0时，表示问卷有问题提交失败，此时重选错误的题目可以触发重新检测
            activeName: 'first',
            is_superior: '否',
            resource_info: [],
            task_id: null,
            RC_todo: 0,
        };
    },
    methods: {
        getToDoNum(num) {
            if(num<0){
                this.RC_todo = null;
            }else{
                this.RC_todo = num;
            }
        },
        handleClick(tab) {
            if(tab.label=='调研任务'){
                if(this.load_user == true){
                    this.$refs.todo_list.getToDoList();
                }                   
            }
            // 20240827 报告功能暂停使用
            // else if(tab.label=='结果报告'){
            //     this.$refs.rc_results.getRCReportList();
            // }
            // console.log(tab, event);
        },
        // 获取RC激励资源问卷
        getRCResource() {
            let params = {
                task_id: this.task_id,
            }
            getdata.getListP("getRCResource", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.resource_info = resp.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        handle_close() {
            // 仅在存在定时任务且有答题记录的情况下，关闭dialog才会触发提交关闭前的最后记录
            if(this.timer_flag==true){
                this.$refs.survey_mana.submitManaQues_timer();
                this.getToDoList();
            }
        },
        start_interval(status) {
            if(status!='已提交'){
                this.timer_flag = true;     // 只在调研未完成的情况下才开启定时提交任务
            }else{
                this.timer_flag = false;
                return;
            }
            // let i = 0;
            this.timer = setInterval(() => {
                if(this.timer_flag==false) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.$refs.survey_mana.submitManaQues_timer();
                // console.log('i: ' + i);
                // i = i + 1;
                //需要定时执行的代码
            },10000)
        },
        clear_interval() {
            this.timer_flag = false;        //关闭对话框时，销毁定时任务
            clearInterval(this.timer);
            this.timer = null;
        },
        start_evaluating(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaQues(task_id);
            this.form = row;
            // 增加task_id的获取，提交问卷需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible = true;
            this.submit_times = 0;
        },
        start_evaluating_survey(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaSurvey(task_id);
            this.form = row;
            // 增加task_id的获取，提交问卷需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible_survey = true;
        },
        view_details(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaQues(task_id, row);
            // 如果是查询详情，则需要使用被评估人id和评估类型，从后台获取评估结果进行展示
            // this.getResultByUser(row.id, row.type, task_id);
            this.form = row;
            // 查询页增加更新功能后，也需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible = true;
            this.submit_times = 0;
        },
        view_details_survey(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            this.getManaSurvey(task_id, row);
            // 如果是查询详情，则需要使用被评估人id和评估类型，从后台获取评估结果进行展示
            // this.getResultByUser_survey(row.id, task_id);   
            this.form = row;
            // 查询页增加更新功能后，也需要补充task_id
            this.form['task_id'] = task_id;
            this.dialogFormVisible_survey = true;
        },
        dialogCancel() {
            this.dialogFormVisible = false;
        },
        dialogCancel_survey() {
            this.dialogFormVisible_survey = false;
        },
        dialogSubmit() {
            // this.timer_flag = false;        //点击按钮提交问卷时，同样销毁定时任务---修改为提交成功才进行销毁
            // clearInterval(this.timer);
            // this.timer = null;
            // 触发子组件的$emit方法向父组件传递数据
            this.$refs.survey_mana.submitManaQues();
            // 答题不完整，check_flag会被设置为false，则终止提交
            // if(this.check_flag == false){
            //     return;
            // }
            // this.dialogFormVisible = false;
            // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
            // this.getToDoList();
            // this.updateToDoNum();
        },
        dialogSubmit_survey() {
            // 触发子组件的$emit方法向父组件传递数据
            this.$refs.survey_mana.submitManaSurvey();
            // 答题不完整，check_flag会被设置为false，则终止提交
            if(this.check_flag == false){
                return;
            }
            // this.dialogFormVisible_survey = false;
            // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
            // this.getToDoList();
            // this.updateToDoNum();
        },
        checkManaQues() {
            for(var cg in this.submit_question_info){
                for(var sj in this.submit_question_info[cg]['subject']){
                    if(this.submit_question_info[cg]['subject'][sj]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag = false;
                        this.error_flag = true;
                        console.log("this.error_flag: " + this.error_flag);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag = true;
            this.error_flag = false;
            console.log("this.error_flag: " + this.error_flag);
        },
        checkManaSurvey() {
            for(var i in this.submit_survey_info){
                if(this.submit_survey_info[i]['choice_type']=='多选' && this.submit_survey_info[i]['selected_option']=='其他'){
                    if(!this.submit_survey_info[i]['proof']){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }else{
                    if(this.submit_survey_info[i]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag_survey = true;
            this.error_flag_survey = false;
        },
        // 父组件获取子组件传递的问卷结果信息
        getQuesResults(data) {
            // 处理问卷结果信息，并提交后台处理
            this.submit_question_info = data[0];
            // 提交问卷前，需要先检查是否有未完成的题目（主要是选择题）---定时任务提交时不做检查
            // if(this.timer_flag==false){
            if(data[2]=='normal'){
                this.checkManaQues();
                if(this.check_flag == false){
                    return;
                }
            }
            // 每次提交记录前，需要重置qid_list和result_list，防止连续提交时数据累加导致结果错误
            this.qid_list = [];
            this.result_list = [];
            let dimension_result = {};  // 增加按照维度统计结果
            // console.log('getData: subject_desc_sub= ' + this.submit_question_info[0]['sub_category'][0]['subject'][0]['subject_desc_sub']);          
            for(var cg in this.submit_question_info){
                dimension_result[this.submit_question_info[cg]['category']] = [];
                for(var sj in this.submit_question_info[cg]['subject']){
                    this.qid_list.push(this.submit_question_info[cg]['subject'][sj]['qid']);
                    this.result_list.push(this.submit_question_info[cg]['subject'][sj]['selected_option']);
                    dimension_result[this.submit_question_info[cg]['category']].push(this.submit_question_info[cg]['subject'][sj]['selected_option'])
                }
            }
            this.submit_proof_info = data[1];
            for(var pf in this.submit_proof_info){
                this.qid_list.push(this.submit_proof_info[pf]['qid']);
                this.result_list.push(this.submit_proof_info[pf]['proof']);
            }
            this.request_info['login_random_series'] = this.login_random_series;
            this.request_info['task_id'] = this.form['task_id'];
            this.request_info['qid_list'] = this.qid_list;
            this.request_info['result_list'] = this.result_list;
            this.request_info['dimension_result'] = dimension_result;
            // if(this.timer_flag==false){
            if(data[2]=='normal'||data[2]=='modify_check'){
                this.request_info['is_user_submit'] = 1;    // 1：标识该内容时用户提交的，非自动提交的
            }else{
                this.request_info['is_user_submit'] = 0;    //定时任务提交时，标识为0
            }
            postdata.postList("submitHealthSurvey", JSON.stringify(this.request_info))
              .then(resp => {
                // if(this.timer_flag==false){     // 定时任务提交时不做结果识别处理
                if(data[2]=='normal'||data[2]=='modify_check'){
                    if(resp.data.code == 200){
                        if(data[2]=='normal') {
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            // 提交成功时才进行销毁定时任务
                            this.timer_flag = false;        //点击按钮提交问卷成功时，同样销毁定时任务
                            clearInterval(this.timer);
                            this.timer = null;
                            // 将关闭窗口改放到这里，超出连续值范围时，不会退出窗口重新答题，可以继续修改后重新提交
                            this.dialogFormVisible = false;
                            this.getToDoList();
                        }
                    }else{
                        // 增加优化，除了提示错误信息，还针对性地对不符合要求的选项标红处理
                        if(resp.data.code == -3){
                            this.submit_times = 1;
                            // 连续值选项超限
                            this.$refs.survey_mana.update_error_info(resp.data.continuous_error_list, resp.data.low_score_error_list);
                        }else if(resp.data.code == -5){
                            this.submit_times = 1;
                            // 高得分选项超限
                            this.$refs.survey_mana.update_error_info(resp.data.continuous_error_list, resp.data.low_score_error_list);
                        }
                        if(data[2]=='normal') {
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                    }
                }else{
                    // 这里改为文字淡入淡出显示 数据已自动保存
                    this.show = true;
                    this.timer2 = setTimeout(() => {
                        this.show = false;
                    }, 3000);
                    this.timer2 = null;
                    clearTimeout(this.timer2);
                    // this.$message({
                    //     message: "数据已自动保存",
                    //     type: "info",
                    //     duration: 1000,
                    //     // showClose: true,
                    // })
                    // this.getToDoList();
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        getSurveyResults(data) {
            // 每次提交记录前，需要重置submit_survey_info，防止连续提交时数据累加导致结果错误
            this.submit_survey_info = [];
            for(var survey in data) {
                var survey_reslut = {};
                survey_reslut['assessee_id'] = this.form['id'];
                survey_reslut['qid'] = data[survey].qid;
                survey_reslut['choice_type'] = data[survey].choice_type;
                survey_reslut['display_num'] = data[survey].display_num;
                survey_reslut['selected_option'] = data[survey].selected_option;
                survey_reslut['proof'] = data[survey].proof;
                survey_reslut['task_id'] = this.form['task_id'];
                this.submit_survey_info.push(survey_reslut);
            }
            this.checkManaSurvey();
            if(this.check_flag_survey == false){
                return;
            }
            
            postdata.postList("submitManaSurvey", JSON.stringify(this.submit_survey_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                    })
                  this.dialogFormVisible_survey = false;
                  this.getToDoList();
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        updateToDoNum() {
            // console.log('updateToDoNum-unfinish_num: ' + this.unfinish_num);
            this.$emit('sendToDoNum', this.unfinish_num);
        },
        getToDoList() {
            let params = {
                login_random_series: this.login_random_series,
                login_task_id: this.login_task_id,
            }
            getdata.getListP("getJKToDoList", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.task_list = resp.data.data;
                        this.unfinish_num = resp.data.unfinish_num;
                        // 获取到未完成评测数后，同步给父组件
                        this.updateToDoNum();
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getManaQues(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getHealthSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.question_info = resp.data.choice;
                    this.proof_info = resp.data.proof;
                    // console.log("question_info: " + this.question_info);
                    // console.log("proof_info" + this.proof_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getManaSurvey(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getManaSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.survey_info = resp.data.survey_info;
                    // console.log("survey_info: " + this.survey_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser_survey(r.id, task_id);  
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getResultByUser(task_id) {
            let params;
            params = {
                login_random_series: this.login_random_series,
                task_id: task_id,
            } 
            
            getdata.getListP("getHealthSurveyResult", params)
            .then(resp => {
                if(resp.data.code == 200){
                    var result = resp.data.data;
                    // console.log('result: ' + result + ' ' + result[0]);
                    var i = 0; 
                    // 首先是选择题
                    for(var cg in this.question_info){
                        for(var sj in this.question_info[cg]['subject']){
                            this.question_info[cg]['subject'][sj]['selected_option'] = result[i];
                            i = i + 1;
                        }
                    }
                    // console.log("question_info2: " + this.question_info);
                    // 然后是举证题
                    for(var pf in this.proof_info){
                        this.proof_info[pf]['proof'] = result[i];
                        i = i + 1;
                    }
                    // console.log("proof_info2: " + this.proof_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },getResultByUser_survey(assessee_id, task_id) {
            let params;
            params = {
                assessee_id: assessee_id,
                task_id: task_id,
            } 
            
            getdata.getListP("getManaSurveyResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    let results = resp.data.data;
                    for(var survey in results) {
                        this.survey_info[survey]['assessee_id'] = results[survey]['assessee_id'];
                        this.survey_info[survey]['qid'] = results[survey]['qid'];
                        this.survey_info[survey]['choice_type'] = results[survey]['choice_type'];
                        this.survey_info[survey]['display_num'] = results[survey]['display_num'];
                        this.survey_info[survey]['selected_option'] = results[survey]['selected_option'];
                        this.survey_info[survey]['proof'] = results[survey]['proof'];
                        this.survey_info[survey]['task_id'] = results[survey]['task_id'];
                    }
                    // console.log("survey_info2: " + this.survey_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    }
};
</script>

<style scoped>
/* .el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
::v-deep .el-tabs__item {
    font-size: 20px;
} */
/* ::v-deep .el-tabs__content {
    margin-top: 50px;
} */
/* .not_start {
    font-size: 12px;
    background: #f56c6c;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.in_process {
    font-size: 12px;
    background: #E6A23C;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.started {
    font-size: 12px;
    background: #67C23A;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
} */
/* ::v-deep .el-dialog {
    height: 600px;
} */
/* 设置dialog的滚动条 */
/* ::v-deep .el-dialog__body {
    max-height: 600px !important;
    min-height: 100px;
    overflow-y: auto;
}
::v-deep .el-collapse-item__header {
    font-size: 18px;
    font-weight: bold;
    color: #409eff;
    padding-left: 10px;
}
.no_task {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
}
::v-deep .el-dialog__header {
    text-align: left;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
} */
</style>